import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import * as R from 'ramda';

import { retrieveInventorySchemas } from '@atom/actions/inventorySchemaActions';
import {
  useGoogleMapsStateValue,
  withGoogleMapsState,
} from '@atom/components/common/map/hooks/googleMapsStateHook';
import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';
import api from '@atom/utilities/api';
import { USERS_ENDPOINT } from '@atom/utilities/endpoints';
import {
  getCurrentUserLocation,
  getGeoJSONLocation,
} from '@atom/utilities/mapUtilities';

import { withKmlLayers } from './hooks/kmlHook';
import { withLayers } from './hooks/layersHook';
import { withListView } from './hooks/listViewHook';
import MapContainer from './MapContainer';
import MapDrawerContent from './MapDrawerContent';
import MapPortalSideNavigation from './MapPortalSideNavigation';

import classes from './mapPortal.module.css';

const MapPortal = () => {
  const dispatch = useDispatch();

  const { isLoaded } = useGoogleMapsStateValue();

  const userId = useSelector(R.pathOr('', ['userProfile', 'userId']));

  useEffect(() => {
    const updateUserLocation = async () => {
      const location = await getCurrentUserLocation();

      if (location && userId) {
        api.patch(`${USERS_ENDPOINT}/${userId}`, {
          location: getGeoJSONLocation(location),
        });
      }
    };

    updateUserLocation();
  }, [userId]);

  useEffect(() => {
    const setSchemas = async () => {
      await dispatch(retrieveInventorySchemas({ rootSchemas: true }));
    };
    setSchemas();
  }, []);

  const [{ collapsed }] = useNavigation({
    collapsed: SearchParamType.BOOLEAN,
  });

  return (
    <div className={classes.container}>
      <div className={classes.title}>Map</div>
      <div className={classes.dashboardContainer}>
        <div className={classes.sideNavContainer}>
          <MapPortalSideNavigation />
        </div>
        <MapDrawerContent />
        {isLoaded && (
          <div
            className={clsx(
              classes.mapContainer,
              !collapsed && classes.expanded,
            )}
          >
            <MapContainer />
          </div>
        )}
      </div>
    </div>
  );
};

export default R.compose(
  withGoogleMapsState,
  withLayers,
  withListView,
  withKmlLayers,
)(MapPortal);
